export const getLoaderTemplate = () => {
  return (
    `<div class="portfolio-v1-popup__loader ui-loader">
      <svg
        class="ui-loader__icon"
        viewBox="0 0 100 100"
        fill="none"
      >
        <circle
          cx="50%"
          cy="50%"
          r="45"
          stroke="currentColor"
          class="ui-loader__circle"
        />
      </svg>
    </div>`
  )
};

export const getContentTemplate = ({ title, description, groups }) => {
  let index = 0;

  return (
    `<div class="portfolio-v1-popup__groups">
      <h2 class="portfolio-v1-popup__title h h--4">
        ${title}
      </h2>

      ${description
        ? `<p class="portfolio-v1-popup__description p p--2">${description}</p>`
        : ''
      }

      ${groups.map(({ title, previews }) => {
        return (
          `<div class="portfolio-v1-popup__preview">
            ${title
              ? `<h3 class="portfolio-v1-popup__subtitle t t--1">
                  ${title}
                </h3>`
              : ''
            }

            <ul class="portfolio-v1-popup__list">
              ${previews.map(({ picture,  description }) => {
                index += 1;

                return (
                  `<li class="portfolio-v1-popup__item">
                    <button
                      class="portfolio-v1-popup__details"
                      type="button"
                      data-details="button"
                      data-index="${index}"
                    >
                      <picture class="portfolio-v1-popup__pic">
                        ${picture.resize.webp
                          ? `<source
                              type="image/webp"
                              srcset="${picture.resize.webp}"
                            >`
                          : ''
                        }

                        <img
                          src="${picture.resize.img}"
                          alt=""
                          decoding="async"
                        >
                      </picture>
                    </button>

                    ${description
                      ?  `<span class="portfolio-v1-popup__desc p p--3">
                            ${description}
                          </span>`
                      : ''
                    }
                  </li>`
                )
              }).join('')}
            </ul>
          </div>`
        )
      }).join('')}
    </div>`
  )
};

export const getNextButtonTemplate = (title) => {
  return (
    `<button
      class="portfolio-v1-popup__button"
      type="button"
    >
      <span class="f f--16">
        Далее
      </span>

      <b class="t t--1">
        ${title}
      </b>

      <svg
        class="portfolio-v1-popup__icon"
        width="8"
        height="14"
        aria-hidden="true"
        viewBox="0 0 7 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1 11l5-4.783L1 1" stroke="currentColor" fill="none" stroke-linecap="round"/>
      </svg>
    </button>`
  )
};

export const getPortfolioTemplate = () => {
  return (
    `<div class="portfolio-v1-popup__wrapper">
      <div class="portfolio-v1-popup__content"></div>
    </div>`
  )
};
